// Narcis's own header slots — the shared chrome (sticky, reveal, `.brand`/`.nav`/`.right` layout) is
// `@core/wall/ui/Header.module.scss` now; this file keeps only what is specific to Narcis's own
// wordmark and nav-link styling (the `--nc-*` tokens, matching `products/narcis/styles/partials/
// colors.scss`'s modern names).

// The lettering of the product's own header (`components/Header/header.module.scss`'s `.wordmark`,
// Fraunces italic 20px), kept over the board's smaller lowercase mark — operator ruling 2026-09-22.
.word {
    font-family: var(--font-display, 'Fraunces', Georgia, serif);
    font-weight: 500;
    font-size: 20px;
    font-style: italic;
    letter-spacing: -0.02em;
    line-height: 1;
    color: var(--text, #faf9f7);
}

.navLink,
.navLinkOn {
    font-size: 13px;
    font-family: var(--font-body, 'Inter', system-ui, sans-serif);
    color: var(--text-muted, #a1a09a);
}

.navLinkOn {
    color: var(--yolk, #e8c24a);
}

@media (max-width: 640px) {
    // The word yields to the mark, as at Toile and Ovid (plan 2026_09_04_wall_header_reveal.md
    // § Step 2) — and as the legacy narcis header already did below 900px.
    .word {
        display: none;
    }
}
